<template>
	<nav id="store-navbar" class="navbar is-white">
		<BaseLoader type="menu" v-if="!isLoaded()"/>
			<div class="navbar-menu is-active" v-if="isLoaded()">
                <template v-if="!loggedIn || !hasCustomerInfo()">
                    <div class="navbar-start">
                        <div class="navbar-item item-login">
                            <p> {{ $appConstants.loginInquiry }} <br/>
                                <a v-if="!isInjectable()"
									tabindex="0"
									@keydown.enter="setModal('login')"
                                    @click="setModal('login')">
                                    Login or Sign-up
                                </a>
                                <navigation-route
                                    v-else
									tabindex="0"
									@keydown.enter="setModal('login')"
                                    @click="setModal('login')"
                                    :link='baseURL + "login"'
                                    :isVueRoute="!isInjectable()"
                                >
                                    Login or Sign-up
                                </navigation-route>
                            </p>
                        </div>
                    </div>
                        <div class="navbar-item">
                            <div class="navbar-item center-nav-item">
                                <div id="location-data" class="has-text-centered">
                                    <navigation-location-mobile />
                                </div>
                            </div>
                        </div>
                    <div class="navbar-end">
                        <div class="navbar-item">
							<navigation-route
								v-if="appIsLoaded && itemCount"
								target="_parent"
								:link='baseURL + "checkout"'
								:isVueRoute="!isInjectable()"
								:key="itemCount"
								classes="button button--checkout is-rounded nav-btn">
									Checkout
									<div class="item-count-background">
										<span class="item-count">
											{{ itemCount }}
										</span>
									</div>
							</navigation-route>
							<p v-else class="loyalty-earnings-message">
								Earn
								<span class="loyalty-pill store-loyalty-color bold-txt">
									{{ $appConstants.loyaltyEarnings }}
								</span>
								with each order
							</p>
                        </div>
                    </div>
                </template>

                <template v-else>
                    <div class="navbar-start">
                        <div class="navbar-item">
							<div class="slide-out-container">
								<SlideoutMenu />
							</div>
                            <div class="is-hidden-tablet-only profile-info-container">
                                <p>
                                    <template v-if="customer.firstName || customer.lastName">
									Hi,
									<a href="/?profile" @click.prevent="setModal('profile')" class="store-navigation-color">
										<strong>{{customer.firstName || customer.lastName}}!</strong>
									</a>
                                    </template>
									<a v-else @click="setModal('profile')" class="store-navigation-color">
										<strong>Edit Profile</strong>
									</a>
									<br/>
									<a class="loyalty-offer-message" @click="setModal('loyalty')" v-if="hasCouponOffers()">
										Offers Available
									</a>
									<span v-if="!hasCouponOffers()">You've earned</span>
									<a href="/?loyalty" aria-label="show loyalty details" @click.prevent="setModal('loyalty')" class="store-loyalty-color">
										<strong><span class="loyalty-pill">{{displayLoyalty}}</span></strong>
										{{ $appConstants.pointsName }}
									</a>
								</p>
                            </div>
                        </div>
                    </div>
                        <div class="navbar-item center-nav-item">
                            <div id="location-data" class="has-text-centered">
                                <navigation-location-mobile />
                            </div>
                        </div>

                    <div class="navbar-end has-text-centered-tablet-only">
                        <navigation-route  
                            v-if="appIsLoaded && itemCount"
                            target="_parent" 
                            :link='baseURL + "checkout"' 
                            :isVueRoute="!isInjectable()"
                            classes="button button--checkout is-rounded nav-btn">
                                Checkout 
                                <div class="item-count-background">
                                    <span class="item-count">
                                        {{ itemCount }}
                                    </span>
                                </div>
                        </navigation-route>
                    </div>
                </template>
            </div>
        </nav>
</template>

<script>
    import { ACCOUNT, LOCATION, CART, ACCOUNT_CHECKOUT, APP_STORE } from '@/stores/defs';
    import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
    import { mapGetters, mapActions } from 'vuex';
	import loyaltyMixin from '@Mixin/loyaltyMixin';
	import modalMixin from '@/components/mixins/modalMixin';
	import offersMixin from '@Mixin/offersMixin';
    import Login from '@/components/auth/Login.vue';
    import Loyalty from "@/components/loyalty/Loyalty";
    import NavigationLocationMobile from '@/components/header/NavigationLocationMobile.vue';
    import NavigationRoute from "@/components/header/NavigationRoute";
    import ProfileEditor from '@/components/account/ProfileEditor';
    import SlideoutMenu from "@/components/header/SlideoutMenu";

    export default {
        mixins: [modalMixin, loyaltyMixin, offersMixin],
        components: {
            'navigation-route': NavigationRoute,
            'navigation-location-mobile': NavigationLocationMobile,
            SlideoutMenu,
        },
        computed: {
            ...mapGetters({
                loggedIn: ACCOUNT.GET_LOGGED_IN,
                customer: ACCOUNT.GET_CUSTOMER,
                location: LOCATION.GET_LOCATION,
                itemCount: CART.ITEM_COUNT,
                orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME,
                serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
                address: ACCOUNT_CHECKOUT.GET_DELIVERY_ADDRESS,
                appIsLoaded: APP_STORE.LOADED
            }),
            baseURL() {
                if (this.isInjectable()) {
                    return process.env.BASE_URL
                } else {
                    return '/';
                }
            }
        },
        methods: {
            ...mapActions({
                setCart: CART.SET_ITEMS,
            }),
            isInjectable() {
                return this.$route.name === 'injectable-header';
            },
            goToLink(link) {
                if (this.isInjectable) {
                    location.href = link;
                } else {
                    this.$router.push({path: link});
                }
            },
            setModal(modalType) {
                const modalWidth = this.$mq === 'mobile' ? '100%' : '65%';
                let modalName = 'contentModal';
                let component, title, showCloseButton = true;
                let contentProps = {};
                if (modalType === 'profile') {
                    component = ProfileEditor;
                    title = 'Profile';
                } else if (modalType === 'loyalty') {
                    component = Loyalty;
                    title = `${this.$appConstants.pointsName} Rewards Program`;
                } else if (modalType === 'login') {
                    component = Login;
                    title = 'Login';
                    modalName = 'loginModal';
                    contentProps =  {
                        routeTo: window.location.pathname || "/"
                    }
                }
                this.triggerModal({
                    classes: 'global-modal',
                    component: component,
                    modalName: modalName,
                    showCloseButton: showCloseButton,
                    title: title,
                    contentProperties: contentProps
                })
			},
        },
        data () {
            return {
                EServiceType: EServiceType,
                isLoaded: () => {
                    // TODO: have separate out once chunking is implemented
					// has "base" key by default
					if (!this.location) {
						return false;
					}
                    return (Object.keys(this.location).length > 2);
                },
                hasCustomerInfo: () => {
                    if (this.customer.id) {
                        return true;
                    }
                    return false;
                }
            }
        },
	}
</script>

<style lang="scss" scoped>
    @import 'globalStyles';

    .navbar-item {
		align-items: flex-start;
		flex: 1;
		padding: 0;
        &.item-login {
			margin: 0.5em 0 0 1em;
            a {
                color: $navigationItemColor;
                font-weight: bold;
            }
		}
		.loyalty-offer-message {
			background-color: $offerHighlight;
			font-weight: bold;
		}
		.slide-out-container {
			margin: 0.8rem 1rem 0 0.8rem;
		}
		.profile-info-container {
			margin: 0.5em 0;
		}
		.loyalty-earnings-message {
			margin: 0.5em;
			justify-self: flex-end;
		}
	}
	
	.center-nav-item {
		justify-content: center;
		margin-top: 0.5em;
	}

    .logo {
        display: block;
		margin: 0 auto;
    }

    .cust-btn {
        width: 12em;
    }

    .button {
        &.is-primary {
            background-color: $storePrimaryButtonColor;
        }
    }

    .button--checkout {
        background-color: $checkoutButtonColor;
		border-color: transparent;

        color: $storeButtonTitleColor;
		animation: animate-in-list cubic-bezier(0.075, 0.82, 0.165, 1) 300ms;

        &:hover {
            border-color: transparent;
            color: $navigationItemTitleActiveColor;
            box-shadow: 0px 0px 3px $checkoutButtonColor;
		}
		&:focus {
			background-color: $checkoutButtonColor;
		}
    }

    #location-data {
        font-size: 0.9rem;
    }
	#location-data .destination-description {
		font-size: 0.9rem;
	}

    .recent-order {
        min-height: 3em;
        display: flex;
        align-items: center;
    }
    .center {
        margin: 0 auto;
	}
	.navbar-start {
        flex: 1;
    }
    .navbar-end {
        margin-right: 0;
		flex: 1;
		.navbar-item {
			justify-content: flex-end;
		}
    }

    .item-count-background {
        display: flex;
        justify-content: center;
        align-items: center;
        
        border-radius: 50%;
        
        width: 1.66rem;
        height: 1.66rem;
        background-color: white;
        margin-left: 0.5em;
    }
    .item-count {
		color: $checkoutButtonColor;
    }

    .separator-vertical {
        height: $navigationBarHeight;
        width: 1px;
        
        background-color: $greyOutline;
    }
    .nav-btn {
        align-self: center;
        padding: 1.3em;
    }

    .sign-out {
        font-size: 11pt;
        a {
            color: $storeButtonColor;
        }
    }
    .navbar-menu.is-active {
        display: flex;
        width: 100vw;
	}
    @include desktop {
        .button--checkout {
			margin: 0.5em;
			justify-self: flex-end;
			align-self: unset;
        }
    }
    @include tablet {
        .button--checkout {
            margin-right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/header/Navigation.vue